<template>
    <div id="myinfo-register-password-1">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="singpassPassword"
          name          ="singpassPassword"
          :type         ="singpassPasswordInputType"
          class         ="password"
          placeholder   =""
          @input        ="onInput($event)"
          minlength     ="8"
          :label        ="$t('general-text-password')"
          outline
          floating-label
          required
        >
          <div class="toggle-password" @click="showHidePassword('singpassPassword')" id="singpass-password-icon" toggle="#singpass-password-field" slot="content-end" style="">
            <i class="f7-icons">eye_slash</i>
          </div>
        </f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  //import { mapGetters, mapActions } from "vuex";
  
  export default {
    props: {
      singpassPasswordInputType:{
        type: String
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {

    },
    methods: {
      showHidePassword(el){
        this.$emit("showHidePassword", el);
      },

      async onInput(e){
        await this.setPassword1(e.target.value);
        await this.validateInput(e.target);
        this.validateNextButton()
      },

      async setPassword1(val){
        this.$emit("setPassword1", val);
      },

      async validateInput(e){
        this.$emit("validateInput", e);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>